import type {LeadStatus, LeadPriority} from 'nutshell-graphql-types';

export const mapLeadStatusApiToString = (status: string): LeadStatus => {
    switch (status) {
        case '0':
            // @ts-expect-error
            return 'OPEN';
        case '1':
            // @ts-expect-error
            return 'PENDING';
        case '10':
            // @ts-expect-error
            return 'WON';
        case '11':
            // @ts-expect-error
            return 'LOST';
        case '12':
            // @ts-expect-error
            return 'CANCELLED';
        default:
            // @ts-expect-error
            return 'OPEN';
    }
};

export const mapLeadPriorityApiToString = (priority: string): LeadPriority => {
    switch (priority) {
        case '1':
            // @ts-expect-error
            return 'HOT';
        case '0':
        default:
            // @ts-expect-error
            return 'NORMAL';
    }
};
